/*! License details at fancyapps.com/license */
const s=(s,t="")=>{s&&s.classList&&t.split(" ").forEach(t=>{t&&s.classList.add(t)})};export{s as addClass};
